export const DEFAULT_PAGE_SIZE = 10;

export const DefaultPaginationConfig = {
    showSizeChanger: true,
    showTotal: (total, range) =>
        `${range[0]}-${range[1]} de ${total} elementos`,
    defaultPageSize: DEFAULT_PAGE_SIZE,
    defaultCurrent: 1,
};
